import PropTypes from 'prop-types';
import * as React from 'react';

function DiagonalBanner({ bannerText }) {
  return (
    <div className="absolute top-0 left-0 -mt-1 transform translate-y-full -translate-x-9">
      <div className="px-12 py-1 font-bold text-white uppercase transform -rotate-45 bg-red-700">
        {bannerText}
      </div>
    </div>
  );
}

DiagonalBanner.propTypes = {
  bannerText: PropTypes.string.isRequired,
};

export { DiagonalBanner };
